import React from 'react';
import { LayersIcon, ActivityIcon, GitCompareIcon, BookOpenIcon, GiftIcon, ClipboardCheckIcon } from 'lucide-react';
const POINTS = [{
  icon: LayersIcon,
  title: 'Des tracés annotés prêts à consulter',
  body: 'Ondes, intervalles et segments repérés directement sur le papier millimétré : ouvrez l’atlas et retrouvez le repère, au lieu de chercher dans plusieurs supports.'
}, {
  icon: ActivityIcon,
  title: 'Une méthode de lecture pour chaque tracé',
  body: 'FRÉQUENCE › RYTHME › AXE › INTERVALLES › ST-T : toujours le même ordre, pour ne rien oublier.'
}, {
  icon: GitCompareIcon,
  title: 'Des comparaisons côte à côte',
  body: 'Normal ou anormal, artefact ou arythmie, FA ou flutter, Mobitz 1 ou Mobitz 2 : chaque confusion fréquente a son repère visuel.'
}, {
  icon: ClipboardCheckIcon,
  title: 'Des fiches et check-lists de terrain',
  body: 'Pose des électrodes, surveillance du scope, signes d’alerte et transmission au format SAED, prêts à l’emploi.'
}, {
  icon: BookOpenIcon,
  title: '6 modules complémentaires',
  body: 'Fondamentaux, lecture systématique, arythmies, ischémie et anomalies, surveillance en pratique clinique, cas cliniques.'
}, {
  icon: GiftIcon,
  title: '5 bonus pratiques',
  body: 'Pose des électrodes, atlas des rythmes, fiches mémo de poche, ECG et médicaments, cahier de 100 tracés.'
}];
export function NotEbook() {
  return <section className="bg-navy py-5 sm:py-7" data-id="element-112" data-mp="2xp4p80jw1sym">
      <div className="mx-auto max-w-5xl px-4 sm:px-6" data-id="element-113" data-mp="2sqbcwbgc8801">
        <h2 className="text-center text-2xl leading-tight text-white sm:text-4xl" data-id="element-114" data-mp="2soqgshedkh02">
          CE N’EST PAS UN SIMPLE EBOOK DE PLUS SUR L’ECG
        </h2>
        <p className="mt-1 text-center font-display text-sm font-bold uppercase leading-tight text-tech-light sm:text-xl" data-id="element-115" data-mp="2jqwkv7kivpdf">
          C’EST UN SYSTÈME VISUEL COMPLET POUR LIRE LES TRACÉS ET TRAVAILLER AVEC MÉTHODE.
        </p>

        <div className="mt-3 grid gap-2 sm:grid-cols-2 sm:gap-2.5" data-id="element-116" data-mp="189er90wno64m">
          {POINTS.map(point => {
          const Icon = point.icon;
          return <div key={point.title} className="flex gap-3 rounded-xl border border-white/15 bg-navy-deep p-3" data-id="element-117" data-mp="1errlh00vu43z">
                <Icon className="mt-0.5 h-5 w-5 shrink-0 text-tech-light" aria-hidden="true" data-id="element-118" data-mp="zw21t8j6632f" />
                <div data-id="element-119" data-mp="14v52yhw13p54">
                  <h3 className="text-sm leading-tight text-white sm:text-base" data-id="element-120" data-mp="r1nimuviq8e1">{point.title}</h3>
                  <p className="mt-0.5 text-sm leading-snug text-white/80" data-id="element-121" data-mp="vsdt2misx1fl">{point.body}</p>
                </div>
              </div>;
        })}
        </div>

        <p className="mt-3 text-center font-display text-sm font-extrabold uppercase text-white sm:text-lg" data-id="element-122" data-mp="h5aq40bpm0kv">
          Moins de lectures au hasard. <span className="text-tech-light" data-id="element-123" data-mp="831gdco9mb8j">Plus de méthode, tracé après tracé.</span>
        </p>
      </div>
    </section>;
}